import moment from 'moment'

export const getTimestampFromString = (string = '') =>
  string ? moment(string).format('x') : ''
